
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-payment-method",
  components: {},
});
